import { TOGGLE_ADD_TAG_MODAL, POST_NEW_TAG, POST_NEW_TAG_SUCCESS } from 'Store/Areas/Import/TagMappingActions';

const initialState = {
  loading: false,
  success: false,
  showModal: false,
  errorMessage: '',
};

export default function addTagReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_ADD_TAG_MODAL:
    case POST_NEW_TAG:
    case POST_NEW_TAG_SUCCESS:
      return Object.assign({}, state, {
        loading: action.loading,
        success: action.success,
        showModal: action.showModal,
        errorMessage: action.errorMessage,
      });
    default:
      return state;
  }
}
